import { Component, OnInit, OnDestroy } from '@angular/core';
import {IWorkshop, WorkshopTool} from '@sv/interfaces';
import {WorkshopService} from '../../../_services/_content/workshop.service';
import {Router} from '@angular/router';

declare var JitsiMeetExternalAPI: any;

@Component({
  selector: 'app-jitsi',
  templateUrl: './jitsi.component.html',
  styleUrls: ['./jitsi.component.scss']
})
export class JitsiComponent implements OnInit, OnDestroy {

  constructor(private workshopService: WorkshopService, private router: Router) { }

  activeWorkshop: IWorkshop;

  isLoading = true;

  options;
  api;
  handler;

  ngOnInit(): void {

    // Get selected Keynote Module from Service
    this.workshopService.getWorkshopListener()
        .subscribe(workshop => {
          this.activeWorkshop = workshop;
        });

    this.options = {
      roomName: 'room1_demo',
      parentNode: document.querySelector('#meet'),
      interfaceConfigOverwrite: {
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        DISPLAY_WELCOME_PAGE_CONTENT: false,
        TOOLBAR_BUTTONS: ['microphone', 'camera', 'raisehand', 'tileview'],
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
        VIDEO_QUALITY_LABEL_DISABLED: true
      },
      userInfo: {
        email:  'lenni.paul@gmx.de',
        displayName: 'Lenny'
      },
    };
    /* this.api = new JitsiMeetExternalAPI(this.activeWorkshop.jitsiDomain, this.options); */
    this.api.executeCommand('toggleTileView');
  }

  ngOnDestroy(): void {
    this.api.dispose();
  }

  changeRoom(room) {
    this.api.dispose();
    this.options = {
      roomName: room + '_demo',
      parentNode: document.querySelector('#meet'),
      interfaceConfigOverwrite: {
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        DISPLAY_WELCOME_PAGE_CONTENT: false,
        TOOLBAR_BUTTONS: ['microphone', 'camera', 'raisehand', 'tileview'],
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
        VIDEO_QUALITY_LABEL_DISABLED: true
      },
      userInfo: {
        email:  'lenni.paul@gmx.de',
        displayName: 'Lenny'
      },
    };
    /* this.api = new JitsiMeetExternalAPI(this.activeWorkshop.jitsiDomain, this.options); */
    this.api.executeCommand('toggleTileView');
  }

}
